module.exports = __webpack_public_path__ + "static/media/reception2.daa4998d.jpg";